import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { BaseCta } from './BaseCta';
export var SignUpCta = function SignUpCta(_ref) {
  var className = _ref.className;
  return React.createElement(BaseCta, {
    className: classNames(className, 'bt--primary bt--outline'),
    href: "/settings/plans?ref=web_studio_detail"
  }, React.createElement(FormattedMessage, {
    id: "schedule.cta.signup",
    defaultMessage: "Sign up"
  }));
};
SignUpCta.propTypes = {
  className: PropTypes.string
};